import React from 'react'

export default () => (
  <>
    <svg
      version="1.1"
      style={{ width: '167px', height: '48px' }}
      className="frw-logo"
      x="0px"
      y="0px"
      viewBox="0 0 128 25"
      shapeRendering="geometricPrecision"
    >
      <g className="frw-logo--color-1">
        <path
          d="
        M 9.54,12.42
        C 9.43,9.13,8.45,9.11,6.2,9.11H5.08v8.22H7.36v.53H0v-.53H2.28V.53H0V0H12.87l.31,5.06h-.43A6,6,0,0,0,11,1.26
        C 10.14.51,9.33.53,7.49.53H5.08v8H6.15
        c 2,0,2.75-.05,3.11-1.14a10.08,10.08,0,0,0,.25-2.28H10v7.29
        Z"
        />
        <path d="M13.64,7.44h4.1v9.89h1.64v.53H13.61v-.53h1.75V8H13.64Zm2.81-7a1.48,1.48,0,0,1,1.49,1.5,1.5,1.5,0,0,1-3,0A1.49,1.49,0,0,1,16.45.4Z" />
        <path
          d="
        M 26.47,8H23.76V15.5
        c 0,.79,0,1.85,1.24,1.85a1.48,1.48,0,0,0,1.52-1.44h.56a2.56,2.56,0,0,1-2.84,2.25,2.57,2.57,0,0,1-2.63-1.49,6.41,6.41,0,0,1-.2-2.33V8
        H 19.77V7.61a6.26,6.26,0,0,0,2.32-1.89,5.28,5.28,0,0,0,1.29-2.48h.38v4.2h2.71
        Z"
        />
        <path
          d="
        M 37.17,14.47a4.35,4.35,0,0,1-4.43,3.69,5.27,5.27,0,0,1-5.21-5.41A5.5,5.5,0,0,1,33,7.13
        c 2.36,0,3.8,1.47,3.8,2.73a1.33,1.33,0,0,1-1.29,1.42,1.25,1.25,0,0,1-1.19-1.34,1.7,1.7,0,0,1,.5-1.19
        c .08-.1.13-.15.13-.25s-.63-.86-2-.86a2.25,2.25,0,0,0-2.27,1.41,15.91,15.91,0,0,0-.43,4.46A8.21,8.21,0,0,0,30.54,16a2.22,2.22,0,0,0,2.28,1.56,3.84,3.84,0,0,0,3.71-3.13Z"
        />
        <path
          d="
        M 37.67,0h4V8.93a4.66,4.66,0,0,1,3.84-1.8,3.77,3.77,0,0,1,2.84,1,3.64,3.64,0,0,1,.6,2.38v6.81h1.67v.53H44.88v-.53h1.61v-7
        c 0-1.06,0-2.48-1.69-2.48A2.77,2.77,0,0,0,42.57,9
        c -.78,1-.83,2-.88,4.07v4.28h1.62v.53H37.54v-.53h1.7V.53H37.67
        Z"
        />
      </g>
      <g className="frw-logo--color-2">
        <path
          d="
        M 67.65,17.53a4.07,4.07,0,0,1-1.9.45,3.62,3.62,0,0,1-2.43-.88
        c -1.21-1.06-1.26-2.58-1.29-4L62,12
        c 0-1-.15-2.45-1.64-3.06a7.8,7.8,0,0,0-3.26-.27v8.65h2.25v.53H52v-.53h2.27V.53H51.89V0h7
        c 2,0,3.87,0,5.33,1.09a3.64,3.64,0,0,1,1.55,3
        c 0,2.56-2.35,4.13-5.47,4.33A6.06,6.06,0,0,1,63.6,9.84a5.22,5.22,0,0,1,1.6,4.45V15a5.11,5.11,0,0,0,.07,1.36,1.2,1.2,0,0,0,1.14,1,3.27,3.27,0,0,0,1.06-.28Z
        M 57.05.56V8.07H58a6.4,6.4,0,0,0,3.52-.66,3.58,3.58,0,0,0,1.21-3A4.87,4.87,0,0,0,62,1.8C61.12.53,59.45.56,57.91.56Z"
        />
        <path
          d="
        M 77,16
        c 0,.86,0,1.47.58,1.47.33,0,.61-.31.79-.46l.3.36a2.56,2.56,0,0,1-1.9.83,2.37,2.37,0,0,1-1.46-.48,2.14,2.14,0,0,1-.71-1.62,3.69,3.69,0,0,1-3.39,2.1
        c -1.6,0-2.86-.91-2.86-2.48s1.16-2.63,2.86-3.16a13.11,13.11,0,0,1,3.44-.43V9.56
        c 0-.73-.1-1.92-1.77-1.92-1.14,0-2.08.68-2.08,1.06s.53.63.53,1.21A1.14,1.14,0,1,1,69,9.81
        c 0-1.24,1.64-2.68,4.2-2.68a4.63,4.63,0,0,1,3,1A3.24,3.24,0,0,1,77,10.67Zm-2.35-3.42
        c -2,0-3.92.61-3.92,2.69A1.57,1.57,0,0,0,72.3,17a2.09,2.09,0,0,0,1.42-.59
        c .81-.78.86-1.66.91-2.95Z"
        />
        <path
          d="
        M 85.16,8H82.45V15.5
        c 0,.79,0,1.85,1.24,1.85a1.48,1.48,0,0,0,1.52-1.44h.56a3,3,0,0,1-5.47.76,6.41,6.41,0,0,1-.2-2.33V8H78.46V7.61
        a 6.26,6.26,0,0,0,2.32-1.89,5.28,5.28,0,0,0,1.29-2.48h.38v4.2h2.71Z"
        />
        <path d="M86.66,7.44h4.1v9.89H92.4v.53H86.64v-.53h1.74V8H86.66Zm2.81-7A1.48,1.48,0,0,1,91,1.9a1.49,1.49,0,0,1-3,0A1.48,1.48,0,0,1,89.47.4Z" />
        <path
          d="
        M 99.25,17.86H93.51v-.53h1.65V8H93.51V7.44h4V9A4.12,4.12,0,0,1,101,7.13
        a 3.7,3.7,0,0,1,2.61,1,3.4,3.4,0,0,1,.83,2.71v6.45h1.67v.53h-5.66v-.53H102V10.52
        a 7.6,7.6,0,0,0-.1-1.49,1.44,1.44,0,0,0-1.49-1.16,2.66,2.66,0,0,0-1.62.6
        c -1.19,1-1.22,2.51-1.24,4.43v4.43h1.69Z"
        />
        <path
          d="
        M 114.1,17.35
        c 1.34,0,3.41,0,3.41,2.81s-2.22,5.06-5.59,5.06
        c -2.73,0-4.85-1.47-4.85-3.24a2.63,2.63,0,0,1,2.07-2.4,2.47,2.47,0,0,1-2-2.36,3.36,3.36,0,0,1,1.19-2.4,8.37,8.37,0,0,1,1.19-.86,3.5,3.5,0,0,1-1.67-3.08
        c 0-2.41,2.07-3.72,4.3-3.72a4.06,4.06,0,0,1,3,1.11,2.85,2.85,0,0,1,1.9-1,1.19,1.19,0,0,1,1.29,1.12,1,1,0,0,1-1,1,.85.85,0,0,1-.88-.7l0-.23
        c 0-.1-.08-.28-.3-.28s-.43.25-.61.43a3.81,3.81,0,0,1,.86,2.4
        c 0,2.28-2,3.67-4.3,3.67a4.34,4.34,0,0,1-2-.46
        c -1,.79-1.77,1.4-1.77,2.18,0,1,1.14,1,2.1,1Zm-1.7,2.38
        c -.93,0-2.07,0-2.8-.05a2.76,2.76,0,0,0-.89,2.05,2.87,2.87,0,0,0,3.21,2.8
        c 3.67,0,4.76-2.5,4.76-3.74s-.71-1.16-2.15-1.14Zm1.29-11.18
        c -.2-.56-.65-.91-1.57-.91-1.61,0-1.66,1.16-1.71,2.1s0,1,0,2.37
        c 0,.76,0,2.05,1.67,2.05a1.64,1.64,0,0,0,1.29-.48
        c .38-.38.43-.71.45-3A10.22,10.22,0,0,0,113.69,8.55Z"
        />
        <path
          d="
        M 119.42,17.86h-.35v-4h.46l.37,1.21A3.23,3.23,0,0,0,123,17.5a2.25,2.25,0,0,0,2.4-2
        c 0-1.24-1.21-1.49-2.1-1.67l-.78-.12a5.59,5.59,0,0,1-1.9-.56,3,3,0,0,1-1.44-2.7,3.19,3.19,0,0,1,3.19-3.32,4,4,0,0,1,2.58,1l.45-.84h.43v3.14h-.48
        a 3,3,0,0,0-3-2.66,2.14,2.14,0,0,0-2.25,1.83
        c 0,1.18,1.54,1.26,2.15,1.44l.91.17c1,.21,3.24.61,3.24,3.39a3.44,3.44,0,0,1-3.44,3.57A4.42,4.42,0,0,1,120.06,17Z"
        />
      </g>
      <g className="frw-logo--color-2">
        <path
          d="
        M 1.6,25.8v3.1H0v-8.7h2.8c0.6,0,1.1,0.1,1.5,0.2c0.4,0.1,0.8,0.3,1,0.6c0.3,0.2,0.5,0.5,0.6,0.9c0.1,0.3,0.2,0.7,0.2,1.1
        c 0,0.4-0.1,0.8-0.2,1.2c-0.1,0.4-0.4,0.7-0.6,0.9c-0.3,0.3-0.6,0.4-1.1,0.6c-0.4,0.1-0.9,0.2-1.5,0.2H1.6z 
        M 1.6,24.6h1.2c0.3,0,0.6,0,0.8-0.1c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7c0-0.2,0-0.4-0.1-0.6
        c -0.1-0.2-0.2-0.3-0.3-0.5s-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.1-0.8-0.1H1.6V24.6z"
        />
        <path
          d="
        M 9.1,25.5v3.4H7.5v-8.7h2.6c0.6,0,1.1,0.1,1.5,0.2c0.4,0.1,0.8,0.3,1,0.5c0.3,0.2,0.5,0.5,0.6,0.8s0.2,0.6,0.2,1c0,0.3,0,0.6-0.1,0.8
        c -0.1,0.3-0.2,0.5-0.4,0.7s-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.3-0.8,0.4c0.2,0.1,0.4,0.3,0.5,0.5l2.2,3.2h-1.5
        c -0.1,0-0.3,0-0.4-0.1s-0.2-0.1-0.2-0.2l-1.8-2.8c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2-0.1-0.4-0.1H9.1z 
        M 9.1,24.3h1c0.3,0,0.6,0,0.8-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.4-0.1-0.8-0.4-1
        c -0.3-0.2-0.7-0.4-1.3-0.4h-1V24.3z"
        />
        <path d="M20.8,20.2v1.3H17v2.4h3v1.2h-3v2.5h3.8v1.3h-5.5v-8.7H20.8z" />
        <path
          d="
        M 21.3,20.2h1.3c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3l2,5.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.1,0.4,0.2,0.7
        c 0.1-0.5,0.2-0.9,0.3-1.2l2-5.3c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1h1.3l-3.5,8.7h-1.5L21.3,20.2z"
        />
        <path d="M32.5,28.9h-1.6v-8.7h1.6V28.9z" />
        <path d="M40,20.2v1.3h-3.8v2.4h3v1.2h-3v2.5H40v1.3h-5.5v-8.7H40z" />
        <path
          d="
        M 40.6,20.2h1.4
        c 0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.2,0.3l1.5,5.2c0,0.1,0.1,0.3,0.1,0.4c0,0.1,0.1,0.3,0.1,0.5c0-0.2,0.1-0.3,0.1-0.5s0.1-0.3,0.1-0.4l1.7-5.2
        c 0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0.5c0.1,0,0.3,0,0.3,0.1s0.2,0.2,0.2,0.3l1.7,5.2c0.1,0.3,0.2,0.5,0.2,0.9
        c 0-0.2,0.1-0.3,0.1-0.4c0-0.1,0.1-0.3,0.1-0.4l1.5-5.2c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1H53l-2.7,8.7h-1.5L46.9,23
        c 0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0,0.1,0,0.2-0.1,0.3s-0.1,0.2-0.1,0.2l-1.9,5.9h-1.5L40.6,20.2z"
        />
      </g>
    </svg>
  </>
)
